module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d6e158311"
    }
  }, [_c('b', [_vm._v("Top Ten Benefits "), _c('i', [_vm._v("of Having Healthy Self-Esteem ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e159111"
    }
  }, [_c('b', [_vm._v("1. ")]), _vm._v("You are more secure in who you are and what you have to offer the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e160311"
    }
  }, [_c('b', [_vm._v("2. ")]), _vm._v("You are able to see the good in others and in the world around you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e161211"
    }
  }, [_c('b', [_vm._v("3. ")]), _vm._v("You are able to move on from the past and experience joy in the present.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e162411"
    }
  }, [_c('b', [_vm._v("4. ")]), _vm._v("Your are able to overcome adversity and setbacks more easily.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e163111"
    }
  }, [_c('b', [_vm._v("5. ")]), _vm._v("You are able to forgive yourself and others.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e164111"
    }
  }, [_c('b', [_vm._v("6. ")]), _vm._v("You have a clear sense of your own values, worth, integrity, and character.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e165311"
    }
  }, [_c('b', [_vm._v("7. ")]), _vm._v("You take better care of your physical and mental health.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e166211"
    }
  }, [_c('b', [_vm._v("8. ")]), _vm._v("You are able to develop a positive philosophy of life and live by that philosophy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e167411"
    }
  }, [_c('b', [_vm._v("9. ")]), _vm._v("You are more optimistic, happier, and able to give of yourself to others.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e168611"
    }
  }, [_c('b', [_vm._v("10. ")]), _vm._v("You are able to take responsibility for your own thoughts, actions, and indeed, your life.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7128f442","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sher_9781440522697_epub_c8_r1.vue
// module id = 81
// module chunks = 0